import { useEffect, useState } from 'react';

// Um minuto de silêncio: uma vela. Antes de começar, ficção apagada; ao toque,
// a chama acende, um anel dourado ao redor enche em 60s e vibra uma vez no fim.
type Estado = 'parado' | 'rodando' | 'feito';

const RAIO = 88;
const VOLTA = 2 * Math.PI * RAIO;

export default function ContadorSilencio({ total = 60 }: { total?: number }) {
  const [restante, setRestante] = useState(total);
  const [estado, setEstado] = useState<Estado>('parado');

  useEffect(() => {
    if (estado !== 'rodando') return;
    if (restante <= 0) {
      setEstado('feito');
      try {
        navigator.vibrate?.(200);
      } catch {
        /* aparelho sem vibração */
      }
      return;
    }
    const t = window.setTimeout(() => setRestante((r) => r - 1), 1000);
    return () => window.clearTimeout(t);
  }, [estado, restante]);

  function acender() {
    setRestante(total);
    setEstado('rodando');
  }

  const totalSeguro = total > 0 ? total : 60;
  const pct = Math.min(1, Math.max(0, (totalSeguro - restante) / totalSeguro));
  const acesa = estado !== 'parado';

  return (
    <div className="flex flex-col items-center">
      <div className="vela">
        {/* Anel de progresso */}
        <svg
          viewBox="0 0 200 200"
          className="absolute inset-0 h-full w-full -rotate-90"
          aria-hidden
        >
          <circle
            cx="100"
            cy="100"
            r={RAIO}
            fill="none"
            stroke="rgba(255,255,255,.12)"
            strokeWidth="4"
          />
          <circle
            cx="100"
            cy="100"
            r={RAIO}
            fill="none"
            stroke="var(--ouro)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={VOLTA}
            strokeDashoffset={VOLTA * (1 - pct)}
            style={{ transition: 'stroke-dashoffset 1s linear' }}
          />
        </svg>

        {acesa && <div className="vela-halo" aria-hidden />}
        <div className="vela-cera" aria-hidden />
        <div className="vela-pavio" aria-hidden />
        {acesa && (
          <div
            className={estado === 'rodando' ? 'vela-chama vela-acende' : 'vela-chama'}
            aria-hidden
          />
        )}
      </div>

      {estado === 'parado' && (
        <button
          type="button"
          onClick={acender}
          className="botao-contorno aperta mt-6 flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 text-[15px]"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-fire-line" aria-hidden />
          </span>
          Acender a vela e começar
        </button>
      )}

      {estado === 'rodando' && (
        <>
          <p className="mt-4 text-[15px] font-semibold text-[color:var(--texto-2)]" aria-live="polite">
            {restante} s
          </p>
          <button
            type="button"
            onClick={() => setEstado('feito')}
            className="aperta mt-2 cursor-pointer whitespace-nowrap px-4 py-2 text-[14px] font-semibold text-[color:var(--texto-2)]"
          >
            Pular
          </button>
        </>
      )}

      {estado === 'feito' && (
        <p className="mt-4 text-[15px] font-semibold text-[color:var(--ouro-forte)]">
          Silêncio feito ✓
        </p>
      )}
    </div>
  );
}